import React, {useEffect, useRef, useState} from 'react'
import {clearFilters, saveFilters, shouldDisplayFonctionnalite} from '../../../../components/helpers'
import {KTIcon} from '../../../../_metronic/helpers'
import FilterPopper from './Televendeur/FilterPopper'
import FavorisPopper from './Televendeur/FavorisPopper'
import {
  activateFavori,
  createFilterFavoris,
  deleteFavoris,
  getFilterFavoris,
  updateFavori,
} from '../../../../components/requests'
import {toast} from 'react-toastify'
import {isEqualWith, isEqual, omit} from 'lodash'

type StatusMode = 'DEMANDE' | 'PIECE'

const DemandeSearchFilter = (props) => {
  const {
    currentUser,
    SelectedClient,
    isPro,
    setClientId,
    setIsClientSociety,
    setIsEdit,
    setDemandeId,
    searchTerm,
    setSearchTerm,
    searchId,
    setSearchId,
    searchPage,
    setSearchPage,
    getClientDemandeData = () => {},
    clientDemandeEtape = [],
    clientDemandeCanal = [],
    clientDemandeEquipe = [],
    dateDebut,
    setDateDebut,
    dateFin,
    setDateFin,
    formik,
    filters,
    setFilters,
    updateFilter = () => {},
    tableRefresh,
    setTableRefresh = () => {},
    baseline,
    setBaseline,
    manualFilters,
    setManualFilters,
    loadFilters = () => {},
    sortConfig,
    setSortConfig = () => {},
    initial,
    favoris,
    setFavoris = () => {},
    openFilter,
    setOpenFilter,
    TRI_KEYS_TABLE_HEADER,
    setSortField,
    setSortOrder,
  } = props
  const [openFavoris, setOpenFavoris] = useState<boolean>(false)
  const [onSave, setOnSave] = useState<boolean>(false)
  const [filterTitle, setFilterTitle] = useState<string>('')
  const [onSubmit, setOnSubmit] = useState<boolean>(false)
  const [favorisLoader, setFavorisLoader] = useState<boolean>(false)
  const [favorisDeleteLoader, setFavorisDeleteLoader] = useState<{[key: string]: boolean}>({})
  const hasInteracted = useRef(false)
  const hasInteractedFilter = useRef(false)
  const [shareWithTeam, setShareWithTeam] = useState<boolean>(false)
  const allowedToManageFavori = shouldDisplayFonctionnalite(currentUser, 'GESTION FAVORI DEMANDE')
  const [showFavori, setShowFavori] = useState<boolean>(false)
  const [statusMode, setStatusMode] = useState<StatusMode>(initial?.statusMode ?? 'DEMANDE')

  {/* Debut Bloc comparaison de donnée */}
  const DATE_KEYS = ['dateDebut', 'dateFin']
  const IGNORED_KEYS = ['id', 'searchPage', 'searchId'] // Comparaison de donnée sans la clé Id et recheche via Id et Texte
  const isBlank = (v) => v === '' || v === null || v === undefined

  const isSameFilters = (a, b) =>
    isEqualWith(omit(a, IGNORED_KEYS), omit(b, IGNORED_KEYS), (valA, valB, key) => {
      // Si la valeur des dates sont "" ou null, alors ils sont identiques
      if (DATE_KEYS.includes(key)) {
        // Les deux vides : égaux
        if (isBlank(valA) && isBlank(valB)) return true
        // Sinon (undefined) : comparaison habituelle de lodash
      }
    })
  {/* Fin Bloc comparaison de donnée */}

  const disableEdit = isSameFilters(filters, baseline)
  const [disableButton, setDisableButton] = useState<boolean>(false)

  // Forcer l'affichage du bouton Modifier pour ne pas dépendre de comparaison isEqual
  useEffect(
    function forceDisableEdit() {
      if (!disableEdit) setDisableButton(true)
    },
    [disableEdit]
  )

  const handleAddDemande = () => {
    if (isPro) {
      setClientId(SelectedClient)
      setIsClientSociety(true)
    }
    setIsEdit(false)
    setDemandeId(null)
    if (searchTerm) setSearchTerm('')
  }

  const handleSearch = () => {
    getClientDemandeData(null)
  }

  useEffect(
    function liveSearchFromSearchBar() {
      setSearchPage(filters?.searchPage)
      setSearchId(filters?.searchId)

      // Ignorer le tout premier rendu si les champs sont vides (état initial)
      if (!hasInteracted.current) {
        if (filters?.searchPage === '' && filters?.searchId === '') return
        hasInteracted.current = true
      } else {
        // if (filters?.searchPage === '' && filters?.searchId === '') return
        saveFilters(filters)
      }

      const timer = setTimeout(() => {
        handleSearch()
      }, 600)

      return () => clearTimeout(timer)
    },
    [filters?.searchPage, filters?.searchId]
  )

  // Rechargement Liste Demande + application filtre
  const commonApplication = (favoris, fromTempApplication: boolean) => {
    const sorting = {
      key: favoris?.filterData?.tri?.key ?? null,
      order: favoris?.filterData?.tri?.order ?? null,
    }

    const nextFilters = {
      ...filters,
      id: favoris?.id ?? null,
      allDemandes: favoris?.filterData?.allDemandes ?? null,
      statut: favoris?.filterData?.statut ?? [],
      source: favoris?.filterData?.source ?? [],
      dateDebut: favoris?.filterData?.dateDebut ?? null,
      dateFin: favoris?.filterData?.dateFin ?? null,
      equipes: favoris?.filterData?.equipes ?? [],
      tri: sorting,
      shareWithTeam: favoris?.filterData?.shareWithTeam ?? [],
      statusMode: favoris?.filterData?.statusMode ?? 'DEMANDE',
    }

    setStatusMode(favoris?.filterData?.statusMode ?? 'DEMANDE')
    setShareWithTeam(favoris?.filterData?.shareWithTeam?.length > 0)
    setFilters(nextFilters)
    // if (TRI_KEYS_TABLE_HEADER?.includes(sorting?.key)) {
    //   setSortField(sorting?.key)
    //   setSortOrder(sorting?.order)
    //   setSortConfig({key: null, order: 'ASC'})
    // } else {
    //   setSortField(null)
    //   setSortOrder('asc')
    // }
    setSortConfig(sorting)
    setDateDebut(favoris?.filterData?.dateDebut ?? null)
    setDateFin(favoris?.filterData?.dateFin ?? null)
    getClientDemandeData(nextFilters)

    // Si donnée baseline === filters, alors le bouton "Valider" sera bloqué (sans changement)
    !fromTempApplication && setBaseline(nextFilters) // Pour ne pas bloquer le bouton "Valider"
  }

  // Fonction du bouton "Modifier"
  const applyFilter = (favoris) => {
    commonApplication(favoris, false)
  }

  // Fonction du bouton "Appliquer"
  const tempApplyFilter = (favoris) => {
    commonApplication(favoris, true)

    if (!isEqual(filters, baseline)) {
      setFavoris((prev) =>
        prev.map((item) => ({
          ...item,
          actif: false,
        }))
      )
    } else {
      setFavoris((prev) =>
        prev.map((item) => ({
          ...item,
          actif: true,
        }))
      )
    }
  }

  // Récupération Favoris
  const fetchFilterFavoris = async () => {
    setFavorisLoader(true)

    try {
      const res = await getFilterFavoris(currentUser.id)

      if (res.data && res.status === 200) {
        const favorisData = res.data.map((fav) => ({
          ...fav,
          actif: !!fav.actif,
        }))

        // Filtre par défaut si aucun favoris actif
        const defaultFilter = {
          id: null,
          filterData: {
            allDemandes: true,
            statut: [],
            source: [],
            dateDebut: null,
            dateFin: null,
            equipes: [],
            tri: {key: 'ID_DEMANDE', order: 'ASC'},
            shareWithTeam: [],
            statusMode: 'DEMANDE',
          },
        }

        if (res?.data?.length !== 0) {
          // Aucun Favoris activé --> Obligation choix Favori pour Modifier si filtre temporaire
          if (initial !== undefined) {
            setFavoris(
              res?.data.map((fav) => ({
                ...fav,
                actif: false,
              }))
            )
          } else {
            setFavoris(favorisData)
          }

          const activeFavoris = favorisData.filter((fav) => fav?.actif)

          if (loadFilters()) return // Chargement des filtres Temporaire s'il y en a

          if (activeFavoris.length) {
            applyFilter(activeFavoris[0])
          } else {
            // Filtre par défaut si aucun favoris actif
            const defaultFilter = {
              id: null,
              filterData: {
                allDemandes: true,
                statut: [],
                source: [],
                dateDebut: null,
                dateFin: null,
                equipes: [],
                tri: {key: 'ID_DEMANDE', order: 'ASC'},
                shareWithTeam: [],
                statusMode: 'DEMANDE',
              },
            }
            applyFilter(defaultFilter)
          }
        } else {
          if (loadFilters()) return // Chargement des filtres Temporaire s'il y en a

          applyFilter(defaultFilter)
        }
      }
    } catch (e) {
      console.error('erreur', e)
    } finally {
      setFavorisLoader(false)
    }
  }

  useEffect(function activateTableRefreshOnFavoriLoad() {
    if (favorisLoader)
      setTableRefresh(true)

  }, [favorisLoader])

  // Création Favoris
  const handleFilterSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setOpenFilter(false)
    const idToastFilterSave = toast.loading('Création du Favori en cours...')
    try {
      const res = await createFilterFavoris(currentUser?.id, filters, filterTitle)

      if (res.data && res.status === 200) {
        // Récupération des favoris
        await fetchFilterFavoris()
        toast.update(idToastFilterSave, {
          render: 'Filtre créé avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
          })
      } else {
        toast.update(idToastFilterSave, {
          render: 'Échec lors de la création du filtre',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.update(idToastFilterSave, {
        render: 'Échec lors de la création du filtre',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    } finally {
      setOnSave(false)
      setOnSubmit(false)
      setFilterTitle('')
      setOpenFilter(false)
      setDisableButton(false)
    }
  }

  // Suppression Favoris
  const handleFavorisDelete = (idFavoris, actif) => {
    const defaultFilter = {
      id: null,
      filterData: {
        allDemandes: true,
        statut: [],
        source: [],
        dateDebut: null,
        dateFin: null,
        equipes: [],
        tri: {key: 'ID_DEMANDE', order: 'ASC'},
        shareWithTeam: [],
        statusMode: 'DEMANDE'
      },
    }
    setFavorisDeleteLoader((prev) => ({...prev, [idFavoris]: true}))
    deleteFavoris(idFavoris).then((res) => {
      if (res.data && res.status === 200) {
        setFavoris((prev) => {
          const updated = prev.filter((favori) => favori.id !== idFavoris)

          // Si tous les favoris ont été supprimés, on applique le filtre par défaut
          if (updated.length === 0) {
            applyFilter(defaultFilter)
          }

          return updated
        })
        setFavorisDeleteLoader((prev) => ({...prev, [idFavoris]: true}))

        // Reset null des filtres si filtre actif est supprimé
        if (actif) {
          applyFilter(defaultFilter)
        }
      }
    })
  }

  const handleFavoriActivation = (favori, actif) => {
    const toastFavUpdate = toast.loading(`${actif ? 'Activation' : 'Désactivation'} du filtre en cours...`)
    if (!actif) {
      const defaultFilter = {
        id: null,
        filterData: {
          allDemandes: true,
          statut: [],
          source: [],
          dateDebut: null,
          dateFin: null,
          equipes: [],
          tri: {key: 'ID_DEMANDE', order: 'ASC'},
          shareWithTeam: [],
          statusMode: 'DEMANDE'
        },
      }
      applyFilter(defaultFilter)
    } else {
      applyFilter(favori)
      clearFilters() // Suppression Filtre Temporaire car activation Favori
    }

    activateFavori(currentUser?.id, favori?.id, actif).then((res) => {
      if (res?.status === 200) {
        toast.update(toastFavUpdate, {
          render: `${actif ? 'Activation' : 'Désactivation'} du filtre avec succès`,
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(toastFavUpdate, {
          render: `${actif ? 'Activation' : 'Désactivation'} du filtre echouée`,
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
        console.error('update failed')
      }
    })
  }
  
  const handleFavoriFilterUpdate = (idFavoris, filterData) => {
    const toastFavUpdate = toast.loading('Mise à jour du filtre en cours...')
    updateFavori(idFavoris, currentUser?.id, filterData).then((res) => {
      if (res?.status === 200) {
        toast.update(toastFavUpdate, {
          render: 'Favori mis à jour avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
        setFavoris((prev) =>
          prev.map((item) => (item?.id === idFavoris ? {...item, filterData: filterData} : item))
        )
        setDisableButton(false)
        clearFilters() // Suppression Filtre Temporaire car activation Favori
      } else {
        toast.update(toastFavUpdate, {
          render: 'Mise à jour échouée',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })

        console.error('update Failed')
      }
    })
  }

  // Récupération des favoris
  useEffect(function fetchFilterFavorisByUser() {
    fetchFilterFavoris()
  }, [])

  return (
    <div>
      <div className='d-flex gap-6 flex-row'>
        <div className={'d-flex gap-3 flex-row'}>
          <div className={'d-flex gap-3 flex-column'}>
            <div className='w-100 position-relative'>
              <i
                className='ki-duotone ki-magnifier fs-2 text-lg-1 text-gray-500 position-absolute top-50 ms-5'
                style={{transform: 'translateY(-50%)'}}
              >
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
              <input
                className='form-control form-control-solid px-15'
                placeholder='Rechercher un client, un immat, un centre,...'
                type='text'
                name='search'
                onChange={(e) => updateFilter('searchPage', e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    // handleSearch()
                    handleSearch()
                  }
                }}
                defaultValue={searchPage}
              />
            </div>
            <div className='w-100 position-relative'>
              <i
                className='ki-duotone ki-magnifier fs-2 text-lg-1 text-gray-500 position-absolute top-50 ms-5'
                style={{transform: 'translateY(-50%)'}}
              >
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
              <input
                className='form-control form-control-solid px-15'
                type='text'
                name='searchId'
                defaultValue={searchId}
                placeholder='Rechercher par numéro'
                onChange={(e) => updateFilter('searchId', e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    // handleSearch()
                    handleSearch()
                  }
                }}
              />
            </div>
          </div>

          <div className={'d-flex gap-2 flex-column w-150px'}>
            <FilterPopper
              clientDemandeEtape={clientDemandeEtape}
              clientDemandeCanal={clientDemandeCanal}
              clientDemandeEquipe={clientDemandeEquipe}
              dateDebut={dateDebut}
              setDateDebut={setDateDebut}
              dateFin={dateFin}
              setDateFin={setDateFin}
              formik={formik}
              filters={filters}
              setFilters={setFilters}
              updateFilter={updateFilter}
              currentUser={currentUser}
              setOpenFavoris={setOpenFavoris}
              openFavoris={openFavoris}
              setOpenFilter={setOpenFilter}
              openFilter={openFilter}
              applyFilter={applyFilter}
              sortConfig={sortConfig}
              setSortConfig={setSortConfig}
              setOnSave={setOnSave}
              onSave={onSave}
              setOnSubmit={setOnSubmit}
              onSubmit={onSubmit}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              handleFilterSave={handleFilterSave}
              getClientDemandeData={getClientDemandeData}
              handleFavoriFilterUpdate={handleFavoriFilterUpdate}
              setShareWithTeam={setShareWithTeam}
              shareWithTeam={shareWithTeam}
              allowedToManageFavori={allowedToManageFavori}
              favoris={favoris}
              setFavoris={setFavoris}
              showFavori={showFavori}
              setShowFavori={setShowFavori}
              disableEdit={disableEdit}
              setBaseline={setBaseline}
              tempApplyFilter={tempApplyFilter}
              manualFilters={manualFilters}
              setManualFilters={setManualFilters}
              disableButton={disableButton}
              setDisableButton={setDisableButton}
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              TRI_KEYS_TABLE_HEADER={TRI_KEYS_TABLE_HEADER}
              setSortField={setSortField}
              setSortOrder={setSortOrder}
            />

            <FavorisPopper
              openFavoris={openFavoris}
              setOpenFavoris={setOpenFavoris}
              setOpenFilter={setOpenFilter}
              currentUser={currentUser}
              setDateDebut={setDateDebut}
              setDateFin={setDateFin}
              applyFilter={applyFilter}
              setFavoris={setFavoris}
              favoris={favoris}
              favorisLoader={favorisLoader}
              handleFavorisDelete={handleFavorisDelete}
              favorisDeleteLoader={favorisDeleteLoader}
              handleFavoriActivation={handleFavoriActivation}
              allowedToManageFavori={allowedToManageFavori}
              clientDemandeEquipe={clientDemandeEquipe}
            />
          </div>
        </div>

        {shouldDisplayFonctionnalite(currentUser, 'AJOUTER DEMANDE') && (
          <div
            className=''
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            style={{width: '32%'}}
          >
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => handleAddDemande()}
              data-bs-target={
                SelectedClient
                  ? isPro
                    ? '#choixContactModal'
                    : '#exampleModalSearchV'
                  : '#exampleModalToggle'
              }
              data-bs-toggle='modal'
            >
              <KTIcon iconName='plus' className='fs-3' />
              Ajouter une demande
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default DemandeSearchFilter